import { CaseRepository } from '@telespot/domain';

export interface ICountCasesByCaseTypeQuery {
  /**
   * Counts cases that belong to the given case type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(caseTypeId: string): Promise<number>;
}

export class CountCasesByCaseTypeQuery implements ICountCasesByCaseTypeQuery {
  constructor(private readonly caseRepository: CaseRepository) {}

  public async execute(caseTypeId: string): Promise<number> {
    return this.caseRepository.countByCaseType(caseTypeId);
  }
}
